<template>
  <div class="row">
    <div class="col-12">
      <div class="bd-gallery-wrapper">
        <swiper :modules="[Autoplay, Navigation, Pagination]" :slides-per-view="4" :space-between="20" :loop="true"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          :pagination="{ clickable: false, el: '.bd-gallery-pagination' }" :navigation="false" class="bd-gallery-active">
          <swiper-slide v-for="(image, index) in images" :key="index">
            <div class="bd-gallery">
              <div class="bd-gallery-thumb-wrapper">
                <div class="bd-gallery-thumb">
                  <img :src="image.src" :alt="image.alt" />
                </div>
                <div class="bd-gallery-icon">
                  <a :href="image.src" class="popup-image"><i class="flaticon-eye"></i></a>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const images = [
  { src: '/img/home/g1.png', alt: 'Gallery Image 1' },
  { src: '/img/home/g2.png', alt: 'Gallery Image 2' },
  { src: '/img/home/g3.png', alt: 'Gallery Image 3' },
  { src: '/img/home/g4.png', alt: 'Gallery Image 4' },
  { src: '/img/home/g1.png', alt: 'Gallery Image 1' },
  { src: '/img/home/g2.png', alt: 'Gallery Image 2' },
  { src: '/img/home/g3.png', alt: 'Gallery Image 3' },
  { src: '/img/home/g4.png', alt: 'Gallery Image 4' },
];
</script>

<style scoped>
.bd-gallery-active {
  position: relative;
}

.bd-gallery-pagination {
  margin-top: 30px;
  text-align: center;
}
</style>
